export default "__VITE_ASSET__P3w3POZ8__"